import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "{2} ",
		d: "M15 19l-7-7 7-7"
	})
});
export default SvgLeftArrow;
